import angular from 'angular';
import {TZ_FILTER} from './timezone-filter-constants';

class TimezoneController {
  static get $inject() {
    return ['$log', '$scope', 'timezonesService'];
  }

  constructor($log, $scope, timezonesService) {
    this.$log = $log;
    this.$scope = $scope;
    this.timezonesService = timezonesService;
    this.TZ_FILTER = TZ_FILTER;

    this.$scope.$watch(
      () => this.timezonesService.data,
      () => this.initTimezone()
    );
  }

  $onInit() {
    if (!this.timezone) {
      this.timezones = this.timezonesService.data;
      this.timezone = this.timezonesService.getGuessedTimezone() || this.timezones[0];
    }
  }

  $onChanges(changes) {
    if (changes.timezoneFilter) {
      this.initTimezone();

      this.ngModel.$render = () => {
        this.timezone = this.ngModel.$viewValue;
      };
      this.setTimezone();
    }
  }

  initTimezone() {
    this.timezones = this.timezonesService.data;

    if (this.timezoneFilter === this.TZ_FILTER.SHOW_FULL_HOURS_ONLY) {
      this.timezones = this.timezonesService.data.filter(
        timezone => this.timezonesService.isFullHourTimezone(timezone)
      );

      if (!this.timezones.includes(this.timezone)) {
        this.timezone = this.timezonesService.findClosestFullHourTimezone(this.timezone);
      }
    }

    if (this.timezoneFilter === this.TZ_FILTER.SHOW_GMT_ONLY) {
      this.timezones = this.timezonesService.data.filter(
        timezone => this.timezonesService.isGmtTimezone(timezone)
      );
      this.timezone = this.timezonesService.getGmtTimezone();
    }
  }

  setTimezone() {
    this.ngModel.$setViewValue(angular.copy(this.timezone));
  }

  searchTimezones(searchTerm) {
    return this.timezones.filter(tz => {
      return tz.displayName.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
    });
  }
}

export default {
  require: {
    ngModel: 'ngModel'
  },
  bindings: {
    timezoneFilter: '<'
  },
  controller: TimezoneController,
  template: `<akam-autocomplete ng-model="$ctrl.timezone"
                                text-property="displayName"
                                minimum-search="0"
                                ng-change="$ctrl.setTimezone()"
                                on-search="$ctrl.searchTimezones(searchTerm)">
             </akam-autocomplete>`
};
